import { tv } from 'tailwind-variants';

/**
 * The logo carries no colour of its own — every path is `fill="currentColor"`,
 * so the surrounding `text-*` decides it. `--teamango-logo` is the brand token and
 * is theme-conditional (see apps/app/src/styles/style.css); anything that wants
 * the logo in a different colour just sets another text colour.
 *
 * `w-auto` on an SVG that has a viewBox and no width/height attributes resolves
 * from the intrinsic aspect ratio, so setting the height is enough.
 */
export const brandLogoTheme = tv({
  base: 'block w-auto shrink-0 text-[var(--teamango-logo)]',
  variants: {
    size: {
      sm: 'h-4',
      md: 'h-[18px]',
      lg: 'h-6',
    },
  },
  defaultVariants: {
    size: 'md',
  },
});
